import React, { useMemo } from "react";
import LinearProgressComponent from "components/Chart/LinearProgress";
import { Ptag } from "components/core/fonts";

const NUMBER_OF_BARS = 6;

function ProgressBar({ data }) {
  const totalValue = useMemo(() => {
    return data.reduce((acc, current) => acc + current.value, 0);
  }, [data]);

  const sortedArray = useMemo(() => {
    return data.sort((a, b) => b.value - a.value);
  }, []);

  const moveNullToLast = (list, key = "name") => {
    return [...list].sort((a, b) => {
      if (a[key] === null) return 1;  // Move 'a' to the end
      if (b[key] === null) return -1; // Keep 'b' after 'a'
      return 0;                       // Keep relative order of other items
    });
  };

  const processedData = useMemo(() => {
    // If there are more than 8 entries, group the rest into "Others"
    let updatedSortedArray = moveNullToLast(sortedArray, "name");
    if (sortedArray.length > NUMBER_OF_BARS) {
      const topEight = updatedSortedArray.slice(0, NUMBER_OF_BARS);
      const others = updatedSortedArray.slice(NUMBER_OF_BARS);

      const othersTotal = others.reduce(
        (acc, current) => acc + current.value,
        0
      );

      // Return top eight plus "Others" category
      return [...topEight, { name: "Others", value: othersTotal }];
    }
    return updatedSortedArray;
  }, [sortedArray]);

  return (
    <div>
      <Ptag fontSize="20px" fontWeight="600" marginTop="1rem" fontFamily="Montserrat">
        Claims Raised by Ailment
      </Ptag>
      {processedData.map((_val) => {
        const percent_complete = (_val.value / totalValue) * 100;
        return (
          <div style={{ margin: "2rem 0" }}>
            <LinearProgressComponent
              value={percent_complete}
              label={_val.name}
              total={_val.value}
            />
          </div>
        );
      })}
    </div>
  );
}

export default ProgressBar;
